import { apiRequest } from '../api';

// Admin → Users → Names & mailboxes (server: routes/people.ts, services/people.ts).
export interface PersonNames {
  id: string; email: string; name: string; nickname: string;
  aliases: string[]; greeting: string; greetsAs: string; active: boolean;
}
export interface RoleMailbox { email: string; personal: boolean }
export interface OfficeMailboxes { legal: string; accounting: string; all: string[]; calendars: string[] }

const BASE = '/people';
export const peopleApi = {
  // any member of staff: the firms' office mailboxes (Admin → Companies)
  offices: (): Promise<OfficeMailboxes> => apiRequest('GET', `${BASE}/offices`),
  settings: (): Promise<{ users: PersonNames[]; mailboxes: RoleMailbox[] }> => apiRequest('GET', `${BASE}/settings`),
  saveNames: (id: string, d: { aliases: string[] | string; greeting: string }): Promise<{ ok: boolean; user: PersonNames }> =>
    apiRequest('PUT', `${BASE}/users/${encodeURIComponent(id)}`, d),
  setPersonal: (email: string, personal: boolean): Promise<{ ok: boolean }> => apiRequest('PUT', `${BASE}/mailboxes`, { email, personal }),
};
